import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { SnackbarProvider } from "notistack";
import Routes from "./routes";
import ThemeCustomization from "./themes";
import { useWhoamiQuery } from "./api/userApi";
import { Loading } from "./components/feedback/Loading";
import { reset, setCredentials } from "./store/global/authSlice";

const App = () => {
    return (
        <ThemeCustomization>
            <SnackbarProvider anchorOrigin={{ horizontal: "center", vertical: "top" }}>
                <Routes />
            </SnackbarProvider>
        </ThemeCustomization>
    );
};

export default App;
